import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import companyLogo from "../../assets/images/logo.png";
import s from "./ThankYouShell.module.scss";

interface ThankYouShellProps {
  icon?: string;
  iconBg?: string;
  iconColor?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
}

const ThankYouShell: React.FC<ThankYouShellProps> = ({
  icon = "mdi-checkbox-marked-circle-outline",
  iconBg,
  iconColor,
  title,
  subtitle,
  children,
  actions,
}) => {
  return (
    <div className={s.root}>
      <div className={s.backgroundDecor} aria-hidden="true">
        <div className={s.blob1} />
        <div className={s.blob2} />
      </div>

      <div className={s.container}>
        <div className={s.logoWrap}>
          <Link to="/">
            <img src={companyLogo} alt="LOVESTRONG Marriage" className={s.logo} />
          </Link>
          <span className={s.badge}>LOVESTRONG MARRIAGE</span>
        </div>

        <div className={s.card}>
          <div
            className={s.iconCircle}
            style={{
              backgroundColor: iconBg,
              color: iconColor,
            }}
          >
            <i className={`mdi ${icon}`} />
          </div>

          <h1 className={s.title}>{title}</h1>
          {subtitle ? <p className={s.subtitle}>{subtitle}</p> : null}

          {children ? <div className={s.content}>{children}</div> : null}

          {actions ? <div className={s.actions}>{actions}</div> : null}
        </div>

        <p className={s.copyright}>
          {"\u00A9"} {new Date().getFullYear()} LOVESTRONG Marriage. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ThankYouShell;
